import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import {
  MOBILE_PRIMARY_ITEMS,
  MOBILE_SECONDARY_SECTIONS,
  isNavItemActive
} from '../../config/navigation';

const navLabel = (item) => item.mobileLabel || item.label;

const MobileBottomNav = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { logout } = useAuth();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  /* Covers the browser back button too, which no link handler sees. */
  useEffect(closeMenu, [location.pathname]);

  useEffect(() => {
    if (!isMenuOpen) return undefined;

    const handleEscape = (event) => {
      if (event.key === 'Escape') closeMenu();
    };

    document.addEventListener('keydown', handleEscape);
    return () => document.removeEventListener('keydown', handleEscape);
  }, [isMenuOpen]);

  const handleLogout = () => {
    logout();
    closeMenu();
    navigate('/login');
  };

  /* Without this the bar shows no active tab at all on any of the nineteen
     pages that are not one of the four, so nothing says where you are. */
  const isOnSecondaryPage = !MOBILE_PRIMARY_ITEMS.some((item) => isNavItemActive(item, location.pathname));

  return (
    <>
      <nav className="mobile-bottom-nav" aria-label="Nawigacja główna">
        {MOBILE_PRIMARY_ITEMS.map((item) => {
          const isActive = isNavItemActive(item, location.pathname);

          return (
            <Link
              key={ item.path }
              to={ item.path }
              className={ `mobile-bottom-nav-item ${isActive ? 'active' : ''}` }
              aria-current={ isActive ? 'page' : undefined }
            >
              <i className={ `fas ${item.icon}` } />
              <span>{navLabel(item)}</span>
            </Link>
          );
        })}

        <button
          type="button"
          className={ `mobile-bottom-nav-item mobile-bottom-nav-more ${isMenuOpen || isOnSecondaryPage ? 'active' : ''}` }
          onClick={ () => setIsMenuOpen(!isMenuOpen) }
          aria-expanded={ isMenuOpen }
          aria-haspopup="dialog"
        >
          <i className={ `fas ${isMenuOpen ? 'fa-xmark' : 'fa-ellipsis'}` } />
          <span>Więcej</span>
        </button>
      </nav>

      {isMenuOpen && (
        <>
          <button type="button" className="mobile-sheet-overlay" onClick={ closeMenu } aria-label="Zamknij menu" />
          <div className="mobile-sheet" role="dialog" aria-label="Więcej">
            <div className="mobile-sheet-handle" />
            <div className="mobile-sheet-header">
              <h3>Wszystkie strony</h3>
              <button type="button" className="btn btn-sm btn-outline-secondary" onClick={ closeMenu }>
                Zamknij
              </button>
            </div>

            {MOBILE_SECONDARY_SECTIONS.map((section) => (
              <div key={ section.id } className="mobile-sheet-section">
                <div className="mobile-sheet-section-title">{section.title}</div>
                <div className="mobile-sheet-links">
                  {section.items.map((item) => {
                    const isActive = isNavItemActive(item, location.pathname);
                    return (
                      <Link
                        key={ item.path }
                        to={ item.path }
                        className={ `mobile-sheet-link ${isActive ? 'active' : ''}` }
                        aria-current={ isActive ? 'page' : undefined }
                        onClick={ closeMenu }
                      >
                        <i className={ `fas ${item.icon}` } />
                        <span>{navLabel(item)}</span>
                      </Link>
                    );
                  })}
                </div>
              </div>
            ))}

            <div className="mobile-sheet-footer">
              <button type="button" className="btn btn-outline-danger w-100" onClick={ handleLogout }>
                <i className="fas fa-sign-out-alt me-2"></i>
                Wyloguj
              </button>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default MobileBottomNav;
